import type { ILocationRepository, LocationListOptions } from '../repositories/ILocationRepository.js';
import type { LocationEntity } from '../entities/LocationEntity.js';

interface Deps { locationRepository: ILocationRepository; }

export function createListLocationsUseCase({ locationRepository }: Deps) {
  return async function listLocations(options?: LocationListOptions): Promise<{ data: LocationEntity[]; total: number }> {
    return locationRepository.list(options);
  };
}
